import Const from '../const'

const urlMap = {
    development: Const.NET.URL_POINT_DEV,
    production: Const.NET.URL_POINT,
}
const baseUrl = urlMap[process.env.NODE_ENV]

export default baseUrl
